import {
    HF_BRAND_COLORS,
    HF_CHART_COLORS,
    HF_CTA_COLORS,
    HF_FONT_FAMILIES,
    HF_NEUTRAL_COLORS,
    HF_TEXT_COLORS
} from './designTokens';

/** Layout tokens for shell, navigation, and shared surfaces.
 *  Values now sourced from `designTokens.ts` — the single source of truth.
 */
export const HF_LAYOUT_COLORS = {
    surface: '#f3f3f4',
    sidebar: '#2f4050',
    border: '#e7eaec',
    navText: '#a7b1c2',
    navActiveAccent: HF_CHART_COLORS.yellow,
    navNested: '#293846',
    rowSelected: HF_CTA_COLORS[100],
    paper: HF_BRAND_COLORS.white
} as const;

export const HF_LAYOUT_SIZES = {
    navBarHeight: 50,
    loginColumnsMaxWidth: 800,
    footerLogoHeight: 24,
    /** Calendar icon inside DatePicker open-picker button (production ~17px). */
    datePickerIconPx: 17
} as const;

/** #content padding (legacy .wrapper-content: 20px 10px 40px). */
export const HF_CONTENT_PADDING = {
    top: 2.5,
    horizontal: 1.25,
    bottom: 5
} as const;

export const HF_LAYOUT_OPACITY = {
    loginFooter: 0.4
} as const;

/** Document-level typography (legacy custom.less body + base.less font stack). */
export const HF_FONT_FAMILY = HF_FONT_FAMILIES.ui;

export const HF_BODY_STYLES = {
    textColor: HF_TEXT_COLORS.body,
    fontFamily: HF_FONT_FAMILIES.ui,
    fontSizePx: 13,
    iosInputFontSizePx: 16
} as const;

// Re-export the underlying scales so consumers can opt in to the wider system
// without crossing the module boundary themselves.
export { HF_BRAND_COLORS, HF_CTA_COLORS, HF_NEUTRAL_COLORS };
